import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { IProyectoModel } from 'src/app/models/interfaces/proyectos/IProyectoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ProyectoModel } from 'src/app/models/proyecto/ProyectoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ProyectoService } from 'src/app/services/proyecto/proyecto.service';

@Component({
  selector: 'app-configuracion-proyecto-registrar',
  templateUrl: './configuracion-proyecto-registrar.component.html',
  styleUrls: ['./configuracion-proyecto-registrar.component.css']
})
export class ConfiguracionProyectoRegistrarComponent implements OnInit {
  model: IProyectoModel = new ProyectoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private proyectoService: ProyectoService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.proyectoService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El proyecto fue registrado");
            this.router.navigate(['/configuracion', 'proyectos']);  
          });
        }
      });
    }
  }

}
